import App from '@/App'
import router from '@/router'
import store from '@/store'

import create from "sso"
import request from 'skytech-request'
import skyEx from '@/common/sky-extends.js'
import commonFn from '@/common/commonFn'
import systemSwitch from "system-switch"
import {
  hideMenu
} from '@/common/jump'

export async function ssoInit(vue) {
  let res = await create({
    request: request,
    currentSys: window,
    mode: process.env.NODE_ENV,
    code: 'oa',
    getHost: window.getDomain
  });
  console.log(process.env)
  if (process.env.NODE_ENV == 'development') {
    console.log(
      `http://localhost:8080/?token=` + localStorage.getItem("Authorization")
    );
  }
  skyEx.add('sso', res);
  vue.use(skyEx);
  let system = systemSwitch.install(res)
  vue.use(system)
  request.install(function (status, message) {
    commonFn.tipPop.error(message)
  })
  let result = await res.checkPermissionInit.getPeoPermission()
  store.commit('FETCH_PERMISSION', result)
	let userInfo = await res.getCurrent();
	store.commit('setUserInfo', userInfo);

  new vue({
    el: '#app',
    router,
    store: store,
    components: {
      App
    },
    mounted() {
      hideMenu()
    },
    template: '<App/>'
  })
}


// WEBPACK FOOTER //
// ./src/common/ssoInit.js